<div *ngIf="deliveryOrderDetails" class="customer-profile-section">
	<!-- Profile Image and Name Section -->
	<div class="flex align-items-end gap-3 mb-4">
		<img class="user-img"
			 *ngIf="deliveryOrderDetails.UserImageUrl; else placeholder"
			 [src]="deliveryOrderDetails.UserImageUrl" />
		<ng-template #placeholder>
			<img class="user-img" src="/XpressApp/assets/images/avatar_placeholder.svg" />
		</ng-template>

		<div class="flex flex-column">
			<div class="user-name mb-1">
				{{ deliveryOrderDetails.UserFirstName | textTransform:TextTransformType.Titlecase }} {{ deliveryOrderDetails.UserLastName | textTransform:TextTransformType.Titlecase }}
			</div>
			<div class="user-phone">{{ deliveryOrderDetails.UserPhoneMask }}</div>
		</div>
	</div>

	<!-- Details Grid -->
	<div class="details-grid">
		<div class="flex align-items-center py-3">
			<div class="field-name w-6">Sign up date:</div>
			<div class="field-value w-6">{{ deliveryOrderDetails.UserCreatedAt | formatDate:'ddd., MMMM D, YYYY, HH:mm' }} ({{ deliveryOrderDetails.UserSignUpDaysPassed }} days)</div>
		</div>
		<div class="flex align-items-center py-3">
			<div class="field-name w-6">Rating:</div>
			<div class="field-value w-6">
				<span class="star-icon">&#9733;</span> {{ userRatingFormatted }}
			</div>
		</div>
		<div class="flex align-items-center py-3">
			<div class="field-name w-6">Account:</div>
			<div class="field-value w-6">
				<span class="lm-active-order-link">{{ (deliveryOrderDetails.LoginProvider || 'Xpress') | textTransform:TextTransformType.Titlecase }}</span>
			</div>
		</div>
		<div class="flex align-items-center py-3">
			<div class="field-name w-6">Application:</div>
			<div class="field-value w-6">
				<span class="badge xpress-app">{{ 'Xpress App' | textTransform:TextTransformType.Titlecase }}</span>
			</div>
		</div>
		<ng-container *ngIf="!isCustomerStatisticsLoading; else customerStatisticsSkeleton">
			<div class="flex align-items-center py-3 border-booking">
				<div class="field-name w-6">Bookings:</div>
				<div class="field-value w-6">{{ deliveryOrderDetails.BookingsCount || '--' }}</div>
			</div>
			<div class="flex align-items-center py-3">
				<div class="field-name w-6">Completed:</div>
				<div class="field-value w-6">{{ deliveryOrderDetails.CompletedCount || '--' }} ({{ deliveryOrderDetails.CompletedPercent || '--' }}%)</div>
			</div>
			<div class="flex align-items-center py-3">
				<div class="field-name w-6">Spend:</div>
				<div class="field-value w-6">{{ deliveryOrderDetails.TotalSpend | formatCurrency | textTransform:TextTransformType.Titlecase }}</div>
			</div>
		</ng-container>
		<ng-template #customerStatisticsSkeleton>
			<div class="flex align-items-center py-3 border-booking">
				<div class="field-name w-6">Bookings:</div>
				<div class="field-value w-6 flex justify-content-end">
					<p-skeleton width="3rem" height="1.25rem"></p-skeleton>
				</div>
			</div>
			<div class="flex align-items-center py-3">
				<div class="field-name w-6">Completed:</div>
				<div class="field-value w-6 flex justify-content-end">
					<p-skeleton width="5.5rem" height="1.25rem"></p-skeleton>
				</div>
			</div>
			<div class="flex align-items-center py-3">
				<div class="field-name w-6">Spend:</div>
				<div class="field-value w-6 flex justify-content-end">
					<p-skeleton width="4.5rem" height="1.25rem"></p-skeleton>
				</div>
			</div>
		</ng-template>
		<div class="flex align-items-center py-3">
			<div class="field-name w-6">Priority:</div>
			<div class="field-value">
				<div class="badge regular" [ngClass]="{'vip': deliveryOrderDetails.IsPriority}">
					{{ (deliveryOrderDetails.IsPriority ? 'VIP' : 'Regular') | textTransform:TextTransformType.Titlecase }}
				</div>
			</div>
		</div>
	</div>
</div>

